module.exports = __webpack_public_path__ + "img/TradingView-icon15_kr.b69b9899.svg";